export default {
  getPendingBillets(state) {
    return state.pendingBillets;
  },
  getPendingBilletInformation(state) {
    return state.pendingBilletInformation;
  },
  getCities(state) {
    return state.cities;
  },
  getSegments(state) {
    return state.segments;
  },
};
